module.exports = __webpack_public_path__ + "16_hair_silver.0e3ccef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/16_hair_silver.png
// module id = U1sW
// module chunks = 0